import {useQuery} from '@tanstack/react-query';
import {type StyleWithImports, getBaseStyle} from 'src/components/map/mapStyleUtils';

const styleId = 'styles/v1/honason/clsrm99s5006e01qtgjfi3lo0';
const token = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;
const mapboxVersion = '3.9.2';

const useBaseStyle = () => {
  const {data: baseStyle} = useQuery<StyleWithImports>({
    queryFn: () =>
      fetch(`https://api.mapbox.com/${styleId}?sdk=js-${mapboxVersion}&access_token=${token}`)
        .then((res) => res.json())
        .then(getBaseStyle),
    queryKey: ['mapbox-style']
  });

  return baseStyle;
};

export default useBaseStyle;
